import(/* webpackMode: "eager", webpackExports: ["ClientOnly"] */ "C:\\Users\\a.carasi\\StudioProjects\\web-maker-admin-2\\src\\app\\[[...slug]]\\client.jsx");
